import { JSONSchema6 } from "json-schema";
 
const data = "data";
 
const getReportsSchema: JSONSchema6 = {
    title: "Get Reports",
    description: "Get Reports details contains list of reports that match the filters that you specify. Where each report contains the details such as report id, report type, processing status and report document id. Report document id will be returned only when the processing status is in complete status.",
    properties: {
        "queryParams": {
            type: "object",
            properties: {
                "reportTypes": {
                    type: "string",
                    enum: ["_GET_FLAT_FILE_OFFAMAZONPAYMENTS_SANDBOX_SETTLEMENT_DATA_"],
                    default: "_GET_FLAT_FILE_OFFAMAZONPAYMENTS_SANDBOX_SETTLEMENT_DATA_"
                },
                "processingStatuses": {
                    type: "string",
                    enum: ["IN_PROGRESS", "COMPLETED", "FAILED", "CANCELLED"]
                },
                "createdSince": {
                    type: "string"
                },
                "createdUntil": {
                    type: "string",
                },
                "pageSize": {
                    type: "string",
                    enum: ["1", "10", "25", "50", "75", "100"],
                    default: "10"
                },
                "nextToken": {
                    type: "string"
                }
            }
        }
    }
}
 
export default getReportsSchema;